import Form from './Form';
import api from '@/plugins/api';

import component from './component.vue';

export default class TourStatistic {
  component = component;
  form = new Form(this);
  __items = [];
  columns = [
    {prop: 'TourName', width: 200, label: 'Название тура', visible: true, index: 1,},
    {prop: 'Country', width: 130, label: 'Страна', visible: true, fixed: false, index: 2},
    {prop: 'City', width: 130, label: 'Город', visible: true, fixed: false, index: 3},
    {prop: 'TouristName', width: 200, label: 'Фамилия Имя Отчество', visible: true, index: 4,},
    {prop: 'AgreementCode', width: 160, label: 'Номер путевки', visible: true, index: 5,},
    {prop: 'PriceForTourist', width: 80, label: 'Цена для туриста', visible: true, index: 6,},
    {prop: 'Partner', width: 200, label: 'Агентство', visible: true, index: 7,},
    {prop: 'PriceForAgency', width: 80, label: 'Цена для агентства', visible: true, index: 8,},
    {prop: 'Price', width: 80, label: 'Себестоимость', visible: true, index: 9,},
    {prop: 'PayedForAgreement', width: 80, label: 'Оплачено за путевку', visible: true, index: 10,},
    {prop: 'DebtForAgreement', width: 80, label: 'Долг за путевку', visible: true, index: 11,},
    {prop: 'StatusAgreement', width: 150, label: 'Статус', visible: true, index: 12,},
    {prop: 'Department', width: 150, label: 'Офис', visible: true, index: 13},
    {prop: 'Manager', width: 150, label: 'Менеджер', visible: true, index: 14,},
    {prop: 'DateCreate', width: 150, label: 'Дата создания', visible: true, index: 15,},
    {prop: 'DateStart', width: 150, label: 'Дата начала поездки', visible: true, index: 16,},
    {prop: 'DateEnd', width: 150, label: 'Дата окончания поездки', visible: true, index: 17,},
    {prop: 'Days', width: 50, label: 'Дней', visible: true, index: 18,},
    {prop: 'ProfitFact', width: 80, label: 'Прибыль факт', visible: true, index: 19,},
    {prop: 'ProfitPlan', width: 80, label: 'Прибыль план', visible: true, index: 20,},
  ]
  loading = false;
  total = 0;
  currentPage = 1;
  perPage = 30;
  orderBy = '-DateCreate';
  dateUpdate = new Date();
  showExport = false;
  url = '';

  get items() {
    return this.__items;
  }

  setSorting(data) {
    const desc = data.value == 'desc' ? '+' : '-';
    const prop = data.prop;
    this.orderBy = desc + prop;
    this.currentPage = 1;
    this.submit();
  }

  currentChange(data) {
    this.currentPage = data;
    this.submit();
  }

  // getLegend() {
  //   return api.settings
  //     .getLegend()
  //     .then((data) => {
  //       console.log(data);
  //       // this.set(data.items?.map(i => ({
  //       //   ...i
  //       // })) || []);
  //     }).finally(() => {
  //       this.loading = false;
  //     });
  //   //const self = this;
  //   // return new Promise((resolve, reject) => {
  //   //   ajax.post()
  //   //     .then(data => {
  //   //       self.columns = data.ItemsLegend.map((item) => {
  //   //         return {
  //   //           prop: item.FieldName,
  //   //           width: item.ColumnWidth,
  //   //           label: item.Name,
  //   //           visible: item.CanVisible,
  //   //           fixed: item.IsFixed,
  //   //           index: item.ColumnIndex,
  //   //         };
  //   //       })
  //   //       resolve(self);
  //   //     }).catch(err => {
  //   //     reject(err);
  //   //   });
  //   // });
  // }

  getUrl(request) {
    let data = `/tourClient/report/report?WebReportId=-114&reportTemplateID=00000000-0000-0000-0000-000000000000&parameters[reportID]=1000005&parameters[OrderBy]=${this.orderBy}`;
    if (request['DateCreate.Serialized']) data += `&parameters[DateCreate.Serialized]=${request['DateCreate.Serialized']}`;
    if (request['DateStart.Serialized']) data += `&parameters[DateStart.Serialized]=${request['DateStart.Serialized']}`;
    if (request['DateEnd.Serialized']) data += `&parameters[DateEnd.Serialized]=${request['DateEnd.Serialized']}`;
    if (request.ProfitPlan) data += `&parameters[ProfitPlan]=${request.ProfitPlan}`;
    if (request.ProfitFact) data += `&parameters[ProfitFact]=${request.ProfitFact}`;
    if (request.Days) data += `&parameters[Days]=${request.Days}`;
    if (request.ManagerId) data += `&parameters[ManagerId]=${request.ManagerId}`;
    if (request.DepartmentId) data += `&parameters[DepartmentId]=${request.DepartmentId}`;
    if (request.PartnerId) data += `&parameters[PartnerId]=${request.Partner}`;
    if (request.StatusAgreement) data += `&parameters[StatusAgreement]=${request.StatusAgreement}`;
    if (request.DebtForAgreement) data += `&parameters[DebtForAgreement]=${request.DebtForAgreement}`;

    if (request.PayedForAgreement) data += `&parameters[PayedForAgreement]=${request.PayedForAgreement}`;
    if (request.Price) data += `&parameters[Price]=${request.Price}`;
    if (request.PriceForAgency) data += `&parameters[PriceForAgency]=${request.PriceForAgency}`;
    if (request.PriceForTourist) data += `&parameters[PriceForTourist]=${request.PriceForTourist}`;
    if (request.TouristName) data += `&parameters[TouristName]=${request.TouristName}`;

    if (request.CityIds) data += `&parameters[CityId]=${request.CityIds}`;
    if (request.CountryId) data += `&parameters[CountryId]=${request.CountryId}`;
    if (request.NameTour) data += `&parameters[NameTour]=${request.NameTour}`;
    if (request.CodeAgreement) data += `&parameters[AgreementCode]=${request.CodeAgreement}`;
    return data;
  }

  set(data) {
    this.__items =
      data.map(i => ({
        Country: i.country,
        City: i.city,
        TourName: i.tourName,
        Tourists: i.tourists,
        AgreementCode: i.agreementCode,
        PriceForTourist: i.priceForTourist,
        Partner: i.partner,
        PriceForAgency: i.priceForAgency,
        Price: i.price,
        PayedForAgreement: i.payedForAgreement,
        DebtForAgreement: i.debtForAgreement,
        StatusAgreement: i.statusAgreement,
        Department: i.department,
        Manager: i.manager,
        DateCreate: i.dateCreate?.serialized,
        DateStart: i.dateStart?.serialized,
        DateEnd: i.dateEnd?.serialized,
        Days: i.days,
        ProfitFact: i.profitFact,
        ProfitPlan: i.profitPlan,
      }));
  }
  init() {
    this.loading = true;
    return Promise
      .all([
        this.form.init(),
      ])
      .finally(() => {
        this.loading = false;
      });
  }

  submit() {
    this.loading = true;
    const request = this.form.data;
    request.perPage = this.perPage;
    request.orderBy = this.orderBy;
    request.currentPage = this.currentPage;
    return api.tour.admin
      .statistic(request)
      .then((data) => {
        this.dateUpdate = new Date();
        this.total = data.total;
        this.url = this.getUrl(request);
        this.showExport = data.total > 0;
        this.set(data.items?.map(i => ({
          ...i
        })) || []);
      }).finally(() => {
        this.loading = false;
      });
  }
}
